import React, { useEffect, useMemo, useState } from 'react'
import axios from '../../../../Axios'
import { Urls } from '../../../../Urls'
import Locked from '../../../Locked/Locked'

const triggerLoginClick = () =>
    document.getElementById('Login_to_view_button').click()

const fetchSignedUrl = (fileName) => axios.post(Urls.fileService, {
    action: 'download',
    accountName: 'lorrifilesproduction',
    containerName: 'private-container',
    fileName,
})

const PlaceholderCard = ({ tag, className = 'turnOver', id }) => (
    <div id={id} className={className}>
        <p>
            <b className="financial_year"> </b><br />
            <span className="financial_tag">{tag}</span><br />
            <b className="amount"><Locked /></b>
        </p>
    </div>
)

const TurnoverCard = ({ entry }) => (
    <div id="turnOver" className="turnOver">
        <p>
            <b className="financial_year"> {entry.financial_year ? <>FY: {entry.financial_year}</> : ''} </b><br />
            <span className="financial_tag">Turnover  (in Crore)</span><br />
            <b className="amount"><Locked /></b>
        </p>
        <p>
            <button className="view-button" id="turnover-view" onClick={triggerLoginClick}>
                <span className="view">View Balance Sheet</span>
            </button>
        </p>
    </div>
)

const NetProfitCard = ({ entry }) => (
    <div id="netProfit" className="netProfit">
        <p>
            <b className="financial_year"> {entry.financial_year ? <>FY: {entry.financial_year}</> : ''}</b><br />
            <span className="financial_tag">Net Profit (in Crore)</span><br />
            <b className="amount"><Locked /></b>
        </p>
        <p className="justify-content-center">
            <button className="view-button" id="netprofit-view" onClick={triggerLoginClick}>
                <span className="view">View PNL Statement</span>
            </button>
        </p>
    </div>
)

const OwnedFleetCard = () => (
    <div className="ownedFleet">
        <p>
            <b className="financial_year"> </b><br />
            <span className="financial_tag">Owned Fleet</span><br />
            <b className="amount"><Locked /></b>
        </p>
        <p>
            <button className="view-button" id="ownedfleet-view" onClick={triggerLoginClick}>
                <span className="view">View</span>
            </button>
        </p>
    </div>
)

const AssociatedFleetCard = () => (
    <div className="ownedFleet">
        <p>
            <b className="financial_year"> </b><br />
            <span className="financial_tag">Associated Fleet</span><br />
            <b className="amount"><Locked /></b>
        </p>
        <p>
            <button className="view-button" id="ownedfleet-view" onClick={triggerLoginClick}>
                <span className="view">View</span>
            </button>
        </p>
    </div>
)

const Intelligence = ({ intelligencedata }) => {
    const { ownedFleet, associatedFleet, latestTurnover, latestNetProfit } = useMemo(() => {
        const data = intelligencedata
        const tov = data?.turnover
        const np = data?.net_profit
        return {
            ownedFleet: data?.owned_fleet,
            associatedFleet: data?.associated_fleet,
            latestTurnover: tov?.length ? tov[tov.length - 1] : null,
            latestNetProfit: np?.length ? np[np.length - 1] : null,
        }
    }, [intelligencedata])

    const [, setDownloadTurnover] = useState('#')
    const [, setDownloadNetProfit] = useState('#')
    const [, setDownloadOwnedFleet] = useState('#')

    useEffect(() => {
        let ignore = false
        const balanceSheet = latestTurnover?.balanceSheet
        if (balanceSheet) {
            fetchSignedUrl(balanceSheet)
                .then(res => { if (!ignore) setDownloadTurnover(res.data.url) })
                .catch(err => { if (!ignore) console.log(err) })
        }
        return () => { ignore = true }
    }, [latestTurnover])

    useEffect(() => {
        let ignore = false
        const pnl = latestNetProfit?.pnl_statement
        if (pnl) {
            fetchSignedUrl(pnl)
                .then(res => { if (!ignore) setDownloadNetProfit(res.data.url) })
                .catch(err => { if (!ignore) console.log(err) })
        }
        return () => { ignore = true }
    }, [latestNetProfit])

    useEffect(() => {
        let ignore = false
        const fleetList = ownedFleet?.fleet_list
        if (fleetList) {
            fetchSignedUrl(fleetList)
                .then(res => { if (!ignore) setDownloadOwnedFleet(res.data.url) })
                .catch(err => { if (!ignore) console.log(err) })
        }
        return () => { ignore = true }
    }, [ownedFleet])

    if (!intelligencedata) {
        return <div><p>Details not available</p></div>
    }

    return (
        <div className="row" style={{ display: 'flex' }}>
            {latestTurnover
                ? <TurnoverCard entry={latestTurnover} />
                : <PlaceholderCard tag="Turnover  (in Crore)" id="turnOver" className="turnOver" />}
            {latestNetProfit
                ? <NetProfitCard entry={latestNetProfit} />
                : <PlaceholderCard tag="Net Profit (in Crore)" id="netProfit" className="netProfit" />}
            {ownedFleet
                ? <OwnedFleetCard />
                : <PlaceholderCard tag="Owned Fleet" className="ownedFleet" />}
            {associatedFleet
                ? <AssociatedFleetCard />
                : <PlaceholderCard tag="Associated Fleet" className="ownedFleet" />}
        </div>
    )
}

export default Intelligence
